import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import CardHeader from "../../Common/CardHeader/CardHeader";
import search from "../../assets/images/search-lg.svg";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { userCategoriesList } from "../../../redux/user/action";
// import DeleteCategory from "./DeleteCategory";
import { deleteOneCategory } from "../../../redux/categories/action";
import {
  deleteOneService,
  getAllServicesList,
} from "../../../redux/service/action";
import DeleteCategory from "../Categories/DeleteCategory";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import { setGetServices } from "../../../redux/reusable/reusableSlice";

const ServiceList = () => {
  const [params, setParams] = useState({
    search_key: "",
    page: 1,
    type: 1,
  });
  const dispatch = useDispatch();
  const [currentComponent, setCurrentComponent] = useState({});
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [modals, setModals] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const serviceList = useSelector((state) => state?.reusableSlice?.getSevices);

  useEffect(() => {
    dispatch(getAllServicesList(params))
      .then((res) => {
        if (res.status) {
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((e) => setIsLoading(false));
      return () =>{
        dispatch(setGetServices([]))
      }
  }, [params, dispatch]);

  const addComponent = () => {
    navigate("/addservices");
  };

  const updateComponent = (id) => {
    navigate(`/updateservices/${id}`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneService(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <>
      {isloading ? (
        <FullScreenLoader />
      ) : (
        <div className="py-3">
          <CardHeader
            headerTitle="Service List"
            params={params}
            setParams={setParams}
            addmodel={addComponent}
            search={search}
            setOpenFilter={setOpenFilter}
            modals={modals}
            setModals={setModals}
          />
          <CardBody className="table-sec px-3">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Title</th>
                  <th scope="col">Ar Title</th>
                  <th scope="col">Position</th>
                  <th scope="col">Status</th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {serviceList?.services?.length > 0 ? (
                  serviceList?.services?.map((item, index) => (
                    <tr key={index}>
                      <td> {index + 1 + (params?.page - 1) * 10}</td>
                      <td>{`${item?.title}`} </td>
                      <td>{item?.ar_title} </td>
                      <td>{item?.position} </td>
                      <td>
                        {item?.status == 1
                          ? "Active"
                          : item?.status == 2
                          ? "Inactive"
                          : ""}{" "}
                      </td>
                      <td>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ columnGap: "10px" }}
                        >
                          <button
                            className="border-button"
                            onClick={() => updateComponent(item?.id)}
                          >
                            <span>Update</span>
                          </button>
                          <button
                            className="background-button"
                            onClick={() => {
                              setModal(true);
                              setCurrentComponent(item);
                            }}
                          >
                            <span>Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Services Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CardBody>
          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={serviceList?.pagination_meta}
          />

          <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
            <DeleteCategory
              modalTitle={"Service"}
              setModal={setModal}
              currentComponent={currentComponent}
              deleteComponent={deleteComponent}
            ></DeleteCategory>
          </Modal>
        </div>
      )}
    </>
  );
};

export default ServiceList;
